module.exports = __webpack_public_path__ + "static/media/Lucario_gaussian2.d511960a.png";